import { PNotifyService } from './../../../services/pnotify.service';
import { ExcelService } from './../../../services/excel.service';
import { AuthService } from './../../../services/auth.service';
import { IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { Component, OnInit, NgZone, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import * as moment from 'moment';
import * as Highcharts from 'highcharts';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NgxRolesService } from 'ngx-permissions';
import { Router } from '@angular/router';
declare var $;
declare var google: any;
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';


@Component({
  selector: 'app-details-activity-report',
  templateUrl: './details-activity-report.component.html',
  styleUrls: ['./details-activity-report.component.css']
})
export class DetailsActivityReportComponent implements OnInit {
  
  filter = {
    clientId: '',
    schoolId: '',
    busIds: [],
    isWeek: true,
    dateInterval: [
      new Date(moment().format('YYYY-MM-DD')),
      new Date(moment().format('YYYY-MM-DD'))
    ],
  };
  isFirstFilter = true;

  staticFilter: any;

  clients: any[];
  schools: any[];
  buses: any[];
  activitiesreport : any[];
  loadData = false;

  public clientsData: any[];
  public schoolsData: any[];
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

   // ----- Start Option Scrollbar -----------
   isScrollbar: true;
   scrollbarOptions = {
     axis: 'y',
     theme: 'minimal-dark'
   };
   // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;

  dtOptions: any = {};

  // ----- Start MultiSelect -----------
  // Settings configuration
  multiSelectSettings: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: true,
    showUncheckAll: true,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block'
  };
  multiSelectSettingsSchool: IMultiSelectSettings = {
    enableSearch: true,
    checkedStyle: 'fontawesome',
    showCheckAll: false,
    showUncheckAll: false,
    buttonClasses: 'btn btn-default btn-block btn-position',
    dynamicTitleMaxItems: 3,
    displayAllSelectedText: true,
    itemClasses: 'MultiSelectItem',
    containerClasses: 'dropdown-block',
    selectionLimit: 1,
    autoUnselect: true
  };
  // Text configuration
  multiSelectTexts: IMultiSelectTexts = {
    checkAll: 'Tout sélectionner',
    uncheckAll: 'Tout déselectionner',
    checked: 'élément sélectionné',
    checkedPlural: 'éléments sélectionnés',
    searchPlaceholder: 'Trouver',
    searchEmptyResult: 'Rien n\'a été trouvé...',
    searchNoRenderText: 'Tapez dans la boîte de recherche pour voir les résultats ...',
    defaultTitle: 'Sélectionner',
    allSelected: 'Tous sélectionnés',
  };
  // ----- End MultiSelect -----------

  // Modal properties
  @ViewChild('modalTimeline') modalTimelineElement: ElementRef;
  showModal: boolean = false;
  modalMap: any;
  modalMarkerBounds: any;
  modalJourneyPolyline: any = null;
  modalJourneyMarkers: any[] = [];
  modalSchoolMarker: any = null;

  // Selected row data
  selectedReport: any = null;

  // Journey data for modal
  modalTrips: any[] = [];
  modalTripsPage: number = 1;
  modalTripsPageSize: number = 9;
  selectedTripId: any = null;
  journeyLoading: boolean = false;

  // Tab state
  modalActiveTab: string = 'trajets';

  // Destinations
  destinations: any[] = [];
  destinationMarkers: any[] = [];
  destinationInfoWindows: any[] = [];
  selectedDestinationIndex: number = -1;

  // Alerts
  modalAlerts: any[] = [];
  alertMarkers: any[] = [];
  alertInfoWindows: any[] = [];
  selectedAlertIndex: number = -1;

  // Playback properties
  localisations: any[] = [];
  markerAnimated: any = null;
  animatedInfoWindow: any = null;
  animationInterval: any = null;
  currentStep: number = 0;
  isPlaying: boolean = false;
  selectedSpeed: number = 1;
  cursorDragging: boolean = false;

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) { 
    this.initClientSelect();
  }

  ngOnInit(): void {
    const columns = [
        { data: 'name' },
        { data: 'matricule' },
        { data: 'date' },
        { data: 'activityStart' },
        { data: 'activityEnd' },
        { data: 'journeysCounter' },
        { data: 'mileage' },
        { data: 'journeysDuration' },
        { data: 'maxSpeed' },
        { data: 'consumption' },
        { data: 'busAlertCounter' },
        { data: 'actions', orderable: false }
    ];

    if (this.roleService.getRole('ROLE_ADMIN')) {
      columns.splice(2, 0, { data: 'schoolName' });
    }

    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/activityReport/datatable',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.activitiesreport = resp.data;
          const dta = [];
          this.activitiesreport.forEach((activityreport, index) => {
            const dateFormatted = activityreport.date ? moment(activityreport.date, ['YYYY-MM-DD', 'YYYYMMDD']).format('DD/MM/YYYY') : '-';
            const startFormatted = activityreport.activityStart ? moment(activityreport.activityStart).format('HH:mm') : '-';
            const endFormatted = activityreport.activityEnd ? moment(activityreport.activityEnd).format('HH:mm') : '-';
            dta.push({
              id: activityreport.id,
              busId: activityreport.Bus.id,
              name: activityreport.Bus.name,
              matricule: activityreport.Bus.matricule,
              date: dateFormatted,
              activityStart: startFormatted,
              activityEnd: endFormatted,
              mileage: activityreport.mileage ,
              journeysDuration: activityreport.journeysDuration,
              journeysCounter: activityreport.journeysCounter,
              maxSpeed: activityreport.maxSpeed ,
              consumption: activityreport.consumption ,
              busAlertCounter: activityreport.busAlertCounter,
              actions: `<a class="btn btnAction btn-detail-action" data-report-id="${activityreport.id}" data-bus-id="${activityreport.Bus.id}" data-date="${activityreport.date}" data-bus-name="${activityreport.Bus.name}">
                <i class="fa fa-search fa-2x"></i>Détail
              </a>`
            });
            if (this.roleService.getRole('ROLE_ADMIN')) {
              dta[index].schoolName = activityreport.Bus.School.name;
            }
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: (nRow, aData, iDataIndex) => {
        $(nRow).attr('id', 'activityReport_' + aData.id);
        $(nRow).find('.btn-detail-action').on('click', () => {
          this.zone.run(() => {
            this.openDetailModal(aData);
          });
        });
      },
      columns: columns,
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };

  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  initClientSelect() {
    if (this.roleService.getRole('ROLE_CLIENT') || this.roleService.getRole('ROLE_SUPER_CLIENT')) {
      const client = this.authService.getUser();
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const client = this.authService.getUser().School.Client;
      this.clients = [{ id: client.id, name: client.name }];
      this.filter.clientId = client.id;
      this.initSchoolSelect();
    } else {
      this.http.get(
        '/api/client/lookup'
      ).subscribe((clients: any[]) => {
        this.clients = clients;
        this.filter.clientId = clients && clients.length ? clients[0].id : '';
        this.clientsData = this.clients.map((client, index) => {
          return { id: client.id, text: client.name, selected: client.id === this.filter.clientId };
        });
        this.initSchoolSelect();
      });
    }
  }

  clientChanged(e: any) {
    this.filter.clientId = e.value;
    this.initSchoolSelect();
  }

  initSchoolSelect() {
    this.filter.schoolId = '';
    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      const school = this.authService.getUser().School;
      this.schools = [{ id: school.id, name: school.name }];
      this.filter.schoolId = school.id;
      this.initBusSelect();
    } else {
      const params = new HttpParams({
        fromObject: {
          clientId: this.filter.clientId
        }
      });
      this.http.get(
        '/api/school/lookup',
        { params }
      ).subscribe((schools: any[]) => {
        this.schools = schools;
        this.filter.schoolId = schools && schools.length ? schools[0].id : '';
        this.schoolsData = this.schools.map((school, index) => {
          return { id: school.id, text: school.name, selected: school.id === this.filter.schoolId };
        });
        this.initBusSelect();
      });
    }
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    this.filter.busIds = [];
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      this.buses = buses;
      console.log(this.buses);
      for (let i = 0; i < this.buses.length; i++) {
        this.filter.busIds.push(this.buses[i].id);
      }
      if (this.isFirstFilter) {
        this.onFilter();
      }
    });
  }

  onReportExport(){
    this.http.post(
      '/api/activityReport/datatable',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {

      const activityReportData = [
        [
          'ID Enreg.',
          'Nom Véhicule',
          'Matricule',
          'Date',
          'Heure début',
          'Heure fin',
          'Distance trajets',
          'Durée trajets',
          'Nombre trajets',
          'Vitesse max',
          'Conso. Carburant (L)',
          'Nombre des alertes'
        ]
      ];

      for (let i = 0; i < resp.data.length; i++) {
        activityReportData.push([
          resp.data[i].id,
          resp.data[i].Bus.name,
          resp.data[i].Bus.matricule,
          resp.data[i].date,
          resp.data[i].activityStart,
          resp.data[i].activityEnd,
          resp.data[i].mileage,
          resp.data[i].journeysDuration,
          resp.data[i].journeysCounter,
          resp.data[i].maxSpeed,
          resp.data[i].consumption,
          resp.data[i].busAlertCounter,
        ]);
      }

      let fileName, sheetName = '';

      if (resp.data[0].Bus.School.name) {
        fileName = 'Export_Activity_Report_' + resp.data[0].Bus.School.name;
      } else {
        fileName = 'Export_Activity_Report';
      }
      
      const currentDate = new Date();
      const day = String(currentDate.getDate()).padStart(2, '0');
      const month = String(currentDate.getMonth() + 1).padStart(2, '0');
      const year = currentDate.getFullYear();

      fileName = `${fileName} ${day}-${month}-${year}`;
      
      sheetName = 'Export-'+`${day}-${month}-${year}`;

      this.excelService.exportAsExcelFileWithMultiplePage([
        {
          name: sheetName,
          data: activityReportData
        },
        ], fileName);

    });

  }

  onFilter() {
    this.staticFilter = {
      clientId: this.filter.clientId,
      schoolId: this.filter.schoolId,
      busIds: JSON.stringify(this.filter.busIds),
      dateInterval: JSON.stringify([
        moment(this.filter.dateInterval[0]).format('YYYY-MM-DD'),
        moment(this.filter.dateInterval[1]).format('YYYY-MM-DD')
      ]),
    };
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

  // ===== Modal methods =====
  openDetailModal(reportData: any) {
    this.selectedReport = reportData;
    this.showModal = true;
    this.modalTrips = [];
    this.modalTripsPage = 1;
    this.selectedTripId = null;
    this.localisations = [];
    this.currentStep = 0;
    this.isPlaying = false;
    this.modalActiveTab = 'trajets';
    this.destinations = [];
    this.selectedDestinationIndex = -1;
    this.clearDestinationMarkers();
    this.modalAlerts = [];
    this.selectedAlertIndex = -1;
    this.clearAlertMarkers();

    // Load journeys for this bus on this date
    const date = reportData.date; // already YYYY-MM-DD or YYYYMMDD
    const dateFormatted = moment(date, ['YYYY-MM-DD', 'YYYYMMDD', 'DD/MM/YYYY']).format('YYYY-MM-DD');
    const params = new HttpParams()
      .set('busIds', JSON.stringify([reportData.busId]))
      .set('date', dateFormatted);

    this.http.get('/api/activityReport/geoDashboard', { params }).subscribe((data: any) => {
      this.modalTrips = (data.trips || []).sort((a, b) => a.startTime - b.startTime);
      this.modalTripsPage = 1;
      this.buildDestinations();
    });

    // Load alerts for this bus on this date
    const alertParams = new HttpParams()
      .set('busId', reportData.busId)
      .set('date', dateFormatted);
    this.http.get('/api/activityReport/busAlerts', { params: alertParams }).subscribe((data: any) => {
      this.modalAlerts = data.alerts || [];
    });

    // Initialize modal map after DOM renders
    setTimeout(() => {
      this.initModalMap();
    }, 300);
  }

  closeDetailModal() {
    this.showModal = false;
    this.stopPlayback();
    this.clearModalJourney();
    this.selectedReport = null;
    this.modalTrips = [];
    this.localisations = [];
    if (this.markerAnimated) {
      this.markerAnimated.setMap(null);
      this.markerAnimated = null;
    }
  }

  initModalMap() {
    let center = { lat: 33.906203, lng: -6.9299658 };
    let schoolName = '';

    // Find current school coordinates
    if (this.schools && this.schools.length) {
      for (let i = 0; i < this.schools.length; i++) {
        if (this.filter.schoolId == this.schools[i].id) {
          center = { lat: parseFloat(this.schools[i].lat), lng: parseFloat(this.schools[i].lng) };
          schoolName = this.schools[i].name;
          break;
        }
      }
    }

    this.modalMap = new google.maps.Map(document.getElementById('modal-map'), {
      zoom: 12,
      center: center,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: false,
      zoomControl: true,
      streetViewControl: false
    });
    this.modalMarkerBounds = new google.maps.LatLngBounds();

    // Add school marker
    if (schoolName) {
      const schoolInfowindow = new google.maps.InfoWindow({
        content: '<b>Éts : </b>' + schoolName
      });
      this.modalSchoolMarker = new google.maps.Marker({
        position: center,
        map: this.modalMap,
        icon: 'assets/images/markers/school.png'
      });
      this.modalSchoolMarker.addListener('click', () => {
        schoolInfowindow.open(this.modalMap, this.modalSchoolMarker);
      });
      this.modalSchoolMarker.addListener('mouseover', () => {
        schoolInfowindow.open(this.modalMap, this.modalSchoolMarker);
      });
      this.modalSchoolMarker.addListener('mouseout', () => {
        schoolInfowindow.close();
      });
    }
  }

  // Journey table pagination
  get modalPagedTrips(): any[] {
    const start = (this.modalTripsPage - 1) * this.modalTripsPageSize;
    return this.modalTrips.slice(start, start + this.modalTripsPageSize);
  }

  get modalTripsTotalPages(): number {
    return Math.ceil(this.modalTrips.length / this.modalTripsPageSize) || 1;
  }

  modalTripsGoToPage(page: number) {
    if (page >= 1 && page <= this.modalTripsTotalPages) {
      this.modalTripsPage = page;
    }
  }

  formatDuration(minutes: number): string {
    if (!minutes && minutes !== 0) { return '-'; }
    if (minutes >= 60) {
      const h = Math.floor(minutes / 60);
      const m = minutes % 60;
      return m > 0 ? h + 'h' + (m < 10 ? '0' : '') + m + 'min' : h + 'h';
    }
    return minutes + ' min';
  }

  // Load and display a journey on the modal map
  showModalJourney(trip: any) {
    this.stopPlayback();
    this.clearModalJourney();
    this.selectedTripId = trip.id;
    this.journeyLoading = true;

    const date = moment(this.selectedReport.date, ['YYYY-MM-DD', 'YYYYMMDD', 'DD/MM/YYYY']).format('YYYY-MM-DD');

    const params = new HttpParams()
      .set('schoolId', this.filter.schoolId)
      .set('busIds', JSON.stringify([trip.busId]))
      .set('date', date)
      .set('timeInterval', JSON.stringify([
        moment.unix(trip.startTime).format('YYYY-MM-DD HH:mm:ss'),
        moment.unix(trip.endTime).format('YYYY-MM-DD HH:mm:ss')
      ]));

    this.http.get('/api/bus/mapJourney', { params }).subscribe((data: any) => {
      this.journeyLoading = false;
      if (!data.positions || !data.positions.length) { return; }

      this.localisations = data.positions;
      this.currentStep = 0;
      const path = [];
      const bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < this.localisations.length; i++) {
        const pos = new google.maps.LatLng(parseFloat(this.localisations[i].lat), parseFloat(this.localisations[i].lng));
        path.push(pos);
        bounds.extend(pos);

        if (i === 0) {
          const startMarker = new google.maps.Marker({
            position: pos,
            map: this.modalMap,
            label: { text: 'D', color: '#fff', fontWeight: 'bold' },
            icon: { path: google.maps.SymbolPath.CIRCLE, scale: 10, fillColor: '#4CAF50', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 }
          });
          const startInfo = new google.maps.InfoWindow({
            content: `<div style="padding:8px;"><b>Départ</b><br><b>Heure :</b> ${moment(trip.startTime * 1000).format('HH:mm')}</div>`
          });
          startMarker.addListener('click', () => { startInfo.open(this.modalMap, startMarker); });
          this.modalJourneyMarkers.push(startMarker);
        }
        if (i === this.localisations.length - 1) {
          const endMarker = new google.maps.Marker({
            position: pos,
            map: this.modalMap,
            label: { text: 'A', color: '#fff', fontWeight: 'bold' },
            icon: { path: google.maps.SymbolPath.CIRCLE, scale: 10, fillColor: '#F44336', fillOpacity: 1, strokeColor: '#fff', strokeWeight: 2 }
          });
          const endInfo = new google.maps.InfoWindow({
            content: `<div style="padding:8px;"><b>Arrivée</b><br><b>Heure :</b> ${moment(trip.endTime * 1000).format('HH:mm')}</div>`
          });
          endMarker.addListener('click', () => { endInfo.open(this.modalMap, endMarker); });
          this.modalJourneyMarkers.push(endMarker);
        }
      }

      this.modalJourneyPolyline = new google.maps.Polyline({
        path: path,
        geodesic: true,
        strokeColor: '#F7941D',
        strokeOpacity: 0.9,
        strokeWeight: 4
      });
      this.modalJourneyPolyline.setMap(this.modalMap);
      this.modalMap.fitBounds(bounds);
    });
  }

  clearModalJourney() {
    if (this.modalJourneyPolyline) {
      this.modalJourneyPolyline.setMap(null);
      this.modalJourneyPolyline = null;
    }
    this.modalJourneyMarkers.forEach(m => m.setMap(null));
    this.modalJourneyMarkers = [];
    if (this.markerAnimated) {
      this.markerAnimated.setMap(null);
      this.markerAnimated = null;
    }
    if (this.animatedInfoWindow) {
      this.animatedInfoWindow.close();
      this.animatedInfoWindow = null;
    }
    this.localisations = [];
    this.currentStep = 0;
    this.selectedTripId = null;
  }

  // ===== Playback methods =====
  togglePlayback() {
    if (this.localisations.length === 0) { return; }
    if (this.isPlaying) {
      this.stopPlayback();
    } else {
      this.startPlayback();
    }
    this.isPlaying = !this.isPlaying;
  }

  startPlayback() {
    if (!this.markerAnimated) {
      this.markerAnimated = new google.maps.Marker({
        position: new google.maps.LatLng(this.localisations[this.currentStep].lat, this.localisations[this.currentStep].lng),
        map: this.modalMap,
        icon: {
          path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
          scale: 5,
          fillColor: '#333333',
          fillOpacity: 0.9,
          rotation: this.localisations[this.currentStep].angle || 0
        }
      });
      this.animatedInfoWindow = new google.maps.InfoWindow();
      this.markerAnimated.addListener('click', () => {
        const pos = this.localisations[this.currentStep];
        const time = pos && pos.time ? moment.utc(pos.time).format('HH:mm:ss') : '-';
        const speed = pos ? (pos.speed || 0) : 0;
        const busName = this.selectedReport ? this.selectedReport.name : '';
        this.animatedInfoWindow.setContent(
          `<div style="padding:8px;font-size:12px;">
            <b>${busName}</b><br>
            <b>Heure :</b> ${time}<br>
            <b>Vitesse :</b> ${speed} km/h<br>
            <b>Lat :</b> ${pos.lat}<br>
            <b>Lng :</b> ${pos.lng}
          </div>`
        );
        this.animatedInfoWindow.open(this.modalMap, this.markerAnimated);
      });
    }

    this.animationInterval = setInterval(() => {
      if (this.currentStep < this.localisations.length - 1) {
        this.currentStep++;
        this.updateAnimatedMarker();
      } else {
        this.currentStep = 0;
        this.isPlaying = false;
        this.stopPlayback();
        if (this.markerAnimated) {
          this.markerAnimated.setMap(null);
          this.markerAnimated = null;
        }
      }
    }, 1000 / this.selectedSpeed);
  }

  stopPlayback() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = null;
    }
  }

  updateAnimatedMarker() {
    if (!this.markerAnimated) { return; }
    const posData = this.localisations[this.currentStep];
    const pos = new google.maps.LatLng(posData.lat, posData.lng);
    this.markerAnimated.setPosition(pos);
    this.markerAnimated.setIcon({
      path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
      scale: 5,
      fillColor: '#333333',
      fillOpacity: 0.9,
      rotation: posData.angle || 0
    });
    // Update info window content if it's open
    if (this.animatedInfoWindow && this.animatedInfoWindow.getMap()) {
      const time = posData.time ? moment.utc(posData.time).format('HH:mm:ss') : '-';
      const speed = posData.speed || 0;
      const busName = this.selectedReport ? this.selectedReport.name : '';
      this.animatedInfoWindow.setContent(
        `<div style="padding:8px;font-size:12px;">
          <b>${busName}</b><br>
          <b>Heure :</b> ${time}<br>
          <b>Vitesse :</b> ${speed} km/h<br>
          <b>Lat :</b> ${posData.lat}<br>
          <b>Lng :</b> ${posData.lng}
        </div>`
      );
    }
  }

  changePlaybackSpeed() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
      this.animationInterval = setInterval(() => {
        if (this.currentStep < this.localisations.length - 1) {
          this.currentStep++;
          this.updateAnimatedMarker();
        } else {
          this.currentStep = 0;
          this.isPlaying = false;
          this.stopPlayback();
          if (this.markerAnimated) {
            this.markerAnimated.setMap(null);
            this.markerAnimated = null;
          }
        }
      }, 1000 / this.selectedSpeed);
    }
  }

  getCursorPercentage(): number {
    if (this.localisations && this.localisations.length > 1) {
      return (this.currentStep / (this.localisations.length - 1)) * 100;
    }
    return 0;
  }

  getPlaybackTime(): string {
    if (this.localisations.length === 0) { return '00:00:00'; }
    const pos = this.localisations[this.currentStep];
    if (pos && pos.time) {
      return moment.utc(pos.time).format('HH:mm:ss');
    }
    return '00:00:00';
  }

  onCursorDrag(event: MouseEvent) {
    if (!this.modalTimelineElement || this.localisations.length === 0) { return; }
    this.cursorDragging = true;
    const timelineRect = this.modalTimelineElement.nativeElement.getBoundingClientRect();
    const offsetX = event.clientX - timelineRect.left;
    const pct = Math.max(0, Math.min(100, (offsetX / timelineRect.width) * 100));
    this.currentStep = Math.round((pct / 100) * (this.localisations.length - 1));
    this.updateAnimatedMarker();

    const moveListener = (e: MouseEvent) => {
      if (this.cursorDragging) {
        const rect = this.modalTimelineElement.nativeElement.getBoundingClientRect();
        const ox = e.clientX - rect.left;
        const p = Math.max(0, Math.min(100, (ox / rect.width) * 100));
        this.currentStep = Math.round((p / 100) * (this.localisations.length - 1));
        this.updateAnimatedMarker();
      }
    };
    const upListener = () => {
      this.cursorDragging = false;
      window.removeEventListener('mousemove', moveListener);
      window.removeEventListener('mouseup', upListener);
    };
    window.addEventListener('mousemove', moveListener);
    window.addEventListener('mouseup', upListener);
  }

  // ===== Tab switching =====
  switchModalTab(tab: string) {
    this.modalActiveTab = tab;
    // Clear everything first
    this.stopPlayback();
    this.clearModalJourney();
    this.clearDestinationMarkers();
    this.selectedDestinationIndex = -1;
    this.clearAlertMarkers();
    this.selectedAlertIndex = -1;

    if (tab === 'destinations') {
      this.showDestinationsOnMap();
    } else if (tab === 'alerts') {
      this.showAlertsOnMap();
    }
  }

  // ===== Destinations methods =====
  buildDestinations() {
    this.destinations = [];
    if (!this.modalTrips || this.modalTrips.length === 0) { return; }

    for (let i = 0; i < this.modalTrips.length; i++) {
      const trip = this.modalTrips[i];
      if (!trip.stopZone) { continue; }

      const parts = trip.stopZone.split(',');
      if (parts.length !== 2) { continue; }

      const lat = parseFloat(parts[0]);
      const lng = parseFloat(parts[1]);
      if (isNaN(lat) || isNaN(lng)) { continue; }

      // Calculate stay duration: time between arrival (endTime of this trip) and departure (startTime of next trip)
      const arrivalTime = moment(trip.endTime * 1000).format('HH:mm');
      let departureTime = '-';
      let stayDuration = '-';

      if (i < this.modalTrips.length - 1) {
        const nextTrip = this.modalTrips[i + 1];
        departureTime = moment(nextTrip.startTime * 1000).format('HH:mm');
        const stayMinutes = Math.round((nextTrip.startTime - trip.endTime) / 60);
        stayDuration = this.formatDuration(stayMinutes);
      } else {
        departureTime = '-';
        const selectedDate = this.selectedReport ? moment(this.selectedReport.date, ['YYYY-MM-DD', 'YYYYMMDD', 'DD/MM/YYYY']).startOf('day') : null;
        const isToday = selectedDate && selectedDate.isSame(moment().startOf('day'));
        stayDuration = isToday ? 'En cours' : 'Fin de journée';
      }

      this.destinations.push({
        lat: lat,
        lng: lng,
        arrivalTime: arrivalTime,
        departureTime: departureTime,
        stayDuration: stayDuration,
        address: lat.toFixed(5) + ', ' + lng.toFixed(5),
        index: i
      });

      // Reverse geocode to get address
      this.reverseGeocode(lat, lng, this.destinations.length - 1);
    }
  }

  reverseGeocode(lat: number, lng: number, destIndex: number) {
    const geocoder = new google.maps.Geocoder();
    const latlng = { lat: lat, lng: lng };
    geocoder.geocode({ location: latlng }, (results, status) => {
      if (status === 'OK' && results && results.length > 0) {
        // Try to find a meaningful short address
        let address = '';
        for (let i = 0; i < results.length; i++) {
          const types = results[i].types;
          if (types.indexOf('route') !== -1 || types.indexOf('neighborhood') !== -1 || 
              types.indexOf('sublocality') !== -1 || types.indexOf('locality') !== -1) {
            address = results[i].formatted_address;
            break;
          }
        }
        if (!address) {
          address = results[0].formatted_address;
        }
        // Shorten address: take first two components
        const parts = address.split(',');
        address = parts.slice(0, 2).join(',').trim();
        if (this.destinations[destIndex]) {
          this.destinations[destIndex].address = address;
        }
      }
    });
  }

  showDestinationsOnMap() {
    this.clearDestinationMarkers();
    if (!this.modalMap || this.destinations.length === 0) { return; }

    const bounds = new google.maps.LatLngBounds();

    this.destinations.forEach((dest, index) => {
      const pos = new google.maps.LatLng(dest.lat, dest.lng);
      bounds.extend(pos);

      const marker = new google.maps.Marker({
        position: pos,
        map: this.modalMap,
        label: { text: String(index + 1), color: '#fff', fontWeight: 'bold', fontSize: '11px' },
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 14,
          fillColor: '#E91E63',
          fillOpacity: 0.9,
          strokeColor: '#fff',
          strokeWeight: 2
        }
      });

      const infoContent = `<div style="padding:10px;font-size:12px;min-width:180px;">
        <b style="font-size:13px;color:#E91E63;">POI ${index + 1}</b><br><br>
        <b>Arrivée :</b> ${dest.arrivalTime}<br>
        <b>Durée d'arrêt :</b> ${dest.stayDuration}<br>
        <b>Départ :</b> ${dest.departureTime}<br>
        <b>Adresse :</b> ${dest.address}
      </div>`;

      const infoWindow = new google.maps.InfoWindow({ content: infoContent });

      marker.addListener('click', () => {
        this.closeAllDestInfoWindows();
        infoWindow.open(this.modalMap, marker);
        this.selectedDestinationIndex = index;
      });

      this.destinationMarkers.push(marker);
      this.destinationInfoWindows.push(infoWindow);
    });

    // Include school marker in bounds if exists
    if (this.modalSchoolMarker) {
      bounds.extend(this.modalSchoolMarker.getPosition());
    }
    this.modalMap.fitBounds(bounds);
  }

  clearDestinationMarkers() {
    this.destinationMarkers.forEach(m => m.setMap(null));
    this.destinationMarkers = [];
    this.destinationInfoWindows.forEach(iw => iw.close());
    this.destinationInfoWindows = [];
  }

  closeAllDestInfoWindows() {
    this.destinationInfoWindows.forEach(iw => iw.close());
  }

  zoomToDestination(index: number) {
    this.selectedDestinationIndex = index;
    if (!this.modalMap || !this.destinationMarkers[index]) { return; }

    const marker = this.destinationMarkers[index];
    this.modalMap.setZoom(16);
    this.modalMap.panTo(marker.getPosition());

    // Close others and open this one
    this.closeAllDestInfoWindows();

    // Update info window content with latest address
    const dest = this.destinations[index];
    const infoContent = `<div style="padding:10px;font-size:12px;min-width:180px;">
      <b style="font-size:13px;color:#E91E63;">POI ${index + 1}</b><br><br>
      <b>Arrivée :</b> ${dest.arrivalTime}<br>
      <b>Durée d'arrêt :</b> ${dest.stayDuration}<br>
      <b>Départ :</b> ${dest.departureTime}<br>
      <b>Adresse :</b> ${dest.address}
    </div>`;
    this.destinationInfoWindows[index].setContent(infoContent);
    this.destinationInfoWindows[index].open(this.modalMap, marker);
  }

  // ===== Alert methods =====
  showAlertsOnMap() {
    this.clearAlertMarkers();
    if (!this.modalMap || this.modalAlerts.length === 0) { return; }

    const bounds = new google.maps.LatLngBounds();

    this.modalAlerts.forEach((alert, index) => {
      if (!alert.lat || !alert.lng) { return; }
      const pos = new google.maps.LatLng(alert.lat, alert.lng);
      bounds.extend(pos);

      const marker = new google.maps.Marker({
        position: pos,
        map: this.modalMap,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
          scale: 10,
          fillColor: '#F44336',
          fillOpacity: 0.9,
          strokeColor: '#fff',
          strokeWeight: 2
        }
      });

      const timeStr = alert.time ? moment.utc(alert.time).format('HH:mm:ss') : '-';
      const infoContent = `<div style="padding:10px;font-size:12px;min-width:180px;">
        <b style="font-size:13px;color:#F44336;">${alert.alertName}</b><br><br>
        <b>Heure :</b> ${timeStr}<br>
        <b>Vitesse :</b> ${alert.speed} km/h<br>
        <b>Détail :</b> ${alert.message || '-'}<br>
        <b>Position :</b> ${alert.lat.toFixed(5)}, ${alert.lng.toFixed(5)}
      </div>`;

      const infoWindow = new google.maps.InfoWindow({ content: infoContent });

      marker.addListener('click', () => {
        this.closeAllAlertInfoWindows();
        infoWindow.open(this.modalMap, marker);
        this.selectedAlertIndex = index;
      });

      this.alertMarkers.push(marker);
      this.alertInfoWindows.push(infoWindow);
    });

    if (this.modalSchoolMarker) {
      bounds.extend(this.modalSchoolMarker.getPosition());
    }
    if (this.alertMarkers.length > 0) {
      this.modalMap.fitBounds(bounds);
    }
  }

  clearAlertMarkers() {
    this.alertMarkers.forEach(m => m.setMap(null));
    this.alertMarkers = [];
    this.alertInfoWindows.forEach(iw => iw.close());
    this.alertInfoWindows = [];
  }

  closeAllAlertInfoWindows() {
    this.alertInfoWindows.forEach(iw => iw.close());
  }

  zoomToAlert(index: number) {
    this.selectedAlertIndex = index;
    if (!this.modalMap || !this.alertMarkers[index]) { return; }

    const marker = this.alertMarkers[index];
    this.modalMap.setZoom(16);
    this.modalMap.panTo(marker.getPosition());

    this.closeAllAlertInfoWindows();

    const alert = this.modalAlerts[index];
    const timeStr = alert.time ? moment.utc(alert.time).format('HH:mm:ss') : '-';
    const infoContent = `<div style="padding:10px;font-size:12px;min-width:180px;">
      <b style="font-size:13px;color:#F44336;">${alert.alertName}</b><br><br>
      <b>Heure :</b> ${timeStr}<br>
      <b>Vitesse :</b> ${alert.speed} km/h<br>
      <b>Détail :</b> ${alert.message || '-'}<br>
      <b>Position :</b> ${alert.lat.toFixed(5)}, ${alert.lng.toFixed(5)}
    </div>`;
    this.alertInfoWindows[index].setContent(infoContent);
    this.alertInfoWindows[index].open(this.modalMap, marker);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/activity-report/details-activity-report/details-activity-report.component.ts